import PropTypes from "prop-types";

function StatOverviewCard({ title, value, unit, details, trend, footer, leads }) {
  return (
    <section className="sd-card sd-stat-card">
      <p className="sd-stat-card__title">{title}</p>
      <div className="sd-stat-card__value-row">
        <span className="sd-stat-card__value">{value}</span>
        {unit ? <span className="sd-stat-card__unit">{unit}</span> : null}
      </div>
      <div className="sd-stat-card__details">
        <div>
          {details?.map((line) => (
            <p key={line}>{line}</p>
          ))}
        </div>
        <div>
          {leads?.map((line) => (
            <p key={line}>{line}</p>
          ))}
        </div>
      </div>
      <div className="sd-stat-card__footer">
        {footer ? <span className="sd-stat-card__footer-text">{footer}</span> : <span />}
        {trend ? (
          <span className={`sd-stat-card__trend ${trend.positive ? "is-up" : "is-down"}`}>
            {trend.text}
          </span>
        ) : null}
      </div>
    </section>
  );
}

StatOverviewCard.defaultProps = {
  unit: "",
  trend: null,
  footer: "",
};

StatOverviewCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  unit: PropTypes.string,
  details: PropTypes.arrayOf(PropTypes.string).isRequired,
  trend: PropTypes.shape({
    text: PropTypes.string,
    positive: PropTypes.bool,
  }),
  footer: PropTypes.string,
};

export default StatOverviewCard;
